/* eslint-disable no-use-before-define, eqeqeq */
import React from 'react'
import { getId, isEmpty, safeNum } from '../../twd/twd'

export const PriceYield = ({priceOrYield, priceYield, setPriceYield, err, bondInfo, action, isLoading, onEnter}) => {
    const id = getId()
    const py = String(priceOrYield)
    const isPrice = py === '1'
    const label = isPrice ? 'Price' : 'Yield'
    const linkLabel = action==='S' && bondInfo.hasBid ? (isPrice ? ' Use best bid price' : ' Use best bid yield')
        : action==='B' && bondInfo.hasAsk ? (isPrice ? ' Use best offer price' : ' Use best offer yield')
        : ''

    const linkField = py==='1' ? 'price'
        : py==='2' ? 'ytm'
        : py==='0' ? 'ytw'
        : ''
    const linkObject = action==='S' && bondInfo.hasBid ? bondInfo.bestoffer.bid
        : action==='B' && bondInfo.hasAsk ? bondInfo.bestoffer.ask
        : null
    const linkValue = linkObject && linkField ? safeNum(linkObject[linkField])
        : null

    React.useEffect(() => {
        if (isEmpty(priceOrYield)) return
        if (isLoading && !isEmpty(priceYield)) return
        setPriceYield(linkValue || '')
    }, [priceOrYield, action])


    return <React.Fragment>
        <div className="vertical-offset-base">
        <div style={{display:'flex'}}>
            <label 
                className="label price-yield-label"
                htmlFor={id}
            >{label}</label>

            <div className="text-body price-yield-link"
            >{linkValue && <button
                type="button"
                className="btn-link"
                onClick={() => {
                    const v = isEmpty(priceYield) || priceYield != linkValue
                        ? linkValue
                        : ''
                    setPriceYield(v)
                }}
                >{linkLabel}</button>}
            </div>
        </div>

        <div className={`${err ? ' has-error' : ''} price-yield-input`}>
        <div className='input-group vertical-offset-xxs'>
            {isPrice && <label className='input-group-addon'>$</label>}
            <input
                className="form-control"
                type="number"
                id={id}
                value={priceYield}
                onChange={(e) => setPriceYield(e.target.value)}
                style={{ ...(isPrice && {paddingLeft:'20px'}) }}
                onKeyUp={(e) => {
                    let key = e.keyCode || e.key || e.which
                    if (!(key===13 || key === 'Enter')) return

                    e.preventDefault()
                    onEnter()
                }}
            />
            <label className='input-group-addon'>{isPrice ? <React.Fragment>&nbsp;</React.Fragment> : '%'}</label>
        </div>
        { err && <label className="field-status has-error">{err}</label> }
        </div>
        </div>

    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/calculator/calc-input/price-yield.js